<template>
    <div class="">
        <div class="box" :class="collapse ? 'box1' : ''">
            <!-- logo -->
            <div>
                <img :class="collapse ? 'logo_img1' : 'logo_img'" :src="collapse ? logo1 : logo" alt="" />
            <!-- 路由 -->
            <el-menu
                class="el_menu"
                :default-active="onRoutes"
                :unique-opened="true"
                router
                :collapse="collapse"
                background-color="#16307C"
                text-color="#ffffff"
                active-text-color="#ffffff"
            >
                <template v-for="item in user_type == 'user' ? items1 : items">
                    <template v-if="item.subs">
                        <el-submenu :index="item.index" :key="item.index" :class="!collapse ? 'submenu' : 'submenu2'">
                            <template slot="title">
                                <div class="flexCenter">
                                    <div
                                        :class="
                                            (!collapse && onRoutes == item.index) ||
                                            ((collapse || !collapse) && onRoutes == 'dispose') ||
                                            ((collapse || !collapse) && onRoutes == 'activation')
                                                ? 'img_box'
                                                : ''
                                        "
                                    >
                                        <img :src="item.img" alt="" class="img_i" />
                                    </div>
                                    <span v-if="!collapse" class="items_title">{{ item.title }}</span>
                                </div>
                            </template>
                            <template v-for="subItem in item.subs">
                                <el-menu-item class="menu_item" :index="subItem.index" :key="subItem.index">
                                    <span class="items_title">{{ subItem.title }}</span>
                                </el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <el-menu-item :index="item.index" :key="item.index" :class="!collapse ? '' : 'is_active1'">
                            <div class="flexCenter">
                                <div
                                    :class="(!collapse && onRoutes == item.index) || (collapse && onRoutes == item.index) ? 'img_box' : ''"
                                >
                                    <img :src="item.img" alt="" class="img_i" />
                                </div>
                                <span v-if="!collapse" class="items_title">{{ item.title }}</span>
                            </div>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
            </div>
         
            <!-- 底部 -->
            <div class="u_footer">
                <div v-if="collapse">
                    <div class="u_fown">
                        <img @click="changeCode" src="../../assets/img/suo.png" class="suo_img" alt="" />
                        <img @click="handleCommand()" src="../../assets/img/pic.png" class="pic_img suo_pic1" alt="" />
                        <!-- <span @click="handleCommand()" class="pic_title">{{user_type|user_type_list}}</span> -->
                    </div>
                </div>
                <div v-else>
                    <div @click="changeCode" class="flexCenter mb27 ml15">
                        <img src="../../assets/img/suo.png" class="suo_img" alt="" />
                        <span class="changeMi">修改密码</span>
                    </div>
                    <div class="mima">
                        <div class="mima_p">
                            <div class="p_l">
                                <img src="../../assets/img/pic.png" class="pic_img" alt="" />
                                <span class="pic_title ml8">{{user_type|user_type_list}}</span>
                            </div>

                            <img src="../../assets/img/user.png" class="right" alt="" @click="handleCommand()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="修改密码" :visible.sync="codeModel" width="648px" top="15vh" class="v_dol">
            <el-form :model="row">
                <el-form-item label="账号所在邮箱">
                    <el-input class="el_input" v-model="row.email" :readonly="true" size="mini"  placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input class="el_input" v-model="row.code" size="mini" clearable placeholder="请输入验证码">
                        <div slot="suffix" v-if="show" class="getCode" @click.stop="senderVerficationCode">获取验证码</div>
                        <div slot="suffix" v-else class="getCode">{{ count }}秒后重发</div>
                    </el-input>
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input class="el_input" v-model="row.password" size="mini" clearable placeholder="请输入新密码"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <div class="v_buttons" @click="resetForm">保 存</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        collapse: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            logo: require('@/assets/img/logo.png'),
            logo1: require('@/assets/img/logo1.png'),
            row: {
                email: '',
                code: '',
                password: ''
            },
            show: true,
            codeModel: false,
            user_type: '',
            items: [
                {
                    icon: 'el-icon-lx-home',
                    img: require('@/assets/img/dashboard.png'),
                    index: 'dashboard',
                    title: '仪表盘'
                },
                {
                    icon: 'el-icon-lx-cascades',
                    img: require('@/assets/img/people-outline.png'),
                    index: 'user',
                    title: '用户管理'
                },
                {
                    icon: 'el-icon-lx-copy',
                    index: 'detail',
                    img: require('@/assets/img/detail.png'),

                    title: '数据明细'
                },
                {
                    icon: 'el-icon-lx-calendar',
                    index: '',
                    img: require('@/assets/img/dispose.png'),
                    title: '奖励管理',
                    subs: [
                        {
                            index: 'dispose',
                            title: '奖励配置'
                        },
                        {
                            index: 'activation',
                            title: '奖励激活'
                        }
                    ]
                },
                {
                    icon: 'el-icon-lx-emoji',
                    index: 'product',
                    img: require('@/assets/img/product.png'),

                    title: '产品管理'
                },
                {
                    icon: 'el-icon-pie-chart',
                    index: 'staff',
                    img: require('@/assets/img/staff.png'),

                    title: '员工设置'
                },
                {
                    icon: 'el-icon-rank',
                    index: 'binding',
                    img: require('@/assets/img/binding.png'),

                    title: '绑定明细'
                },
                {
                    icon: 'el-icon-lx-global',
                    index: 'record',
                    img: require('@/assets/img/record.png'),

                    title: '修改日志'
                },
                {
                    icon: 'el-icon-lx-global',
                    index: 'unknown',
                    img: require('@/assets/img/unknown.png'),

                    title: '未知用户'
                }
            ],
            items1: [
                {
                icon: 'el-icon-lx-cascades',
                    img: require('@/assets/img/people-outline.png'),
                    index: 'user',
                    title: '用户管理'
                },
                {
                    icon: 'el-icon-lx-copy',
                    index: 'detail',
                    img: require('@/assets/img/detail.png'),

                    title: '数据明细'
                },
                
            ]
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        },

        username() {
            let username = localStorage.getItem('user');
            console.log(username);
            let user = JSON.parse(username);
            return user.email;
        }
    },
    created() {
        let username = localStorage.getItem('user');
            let user = JSON.parse(username);
            this.row.email=user.email
        let user_type = localStorage.getItem('user_type');
        this.user_type = user_type;
    },
    methods: {
        // 修改密码
        changeCode() {
            this.codeModel = true;
        },
        senderVerficationCode() {
            if (this.row.email == '') {
                this.$message.error('请输入邮箱');
                return;
            }
            let TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                let timer = 0;
                timer = setInterval(() => {
                    if (this.count > 0 && this.count <= 120) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(timer);
                        timer = 0;
                    }
                }, 1000);

                this.getcode();
            }
        },
        getcode() {
            let that = this;
            let obj = {
                email: that.row.email
            };
            that.$post('/backapi/send_code', obj).then(function (res) {
                if (res.code == 200) {
                    that.$message.success('发送成功');
                } else {
                    that.$message.error(res.msg);
                }
            });
        },
        resetForm() {
            let that = this;
            if (that.row.code == '') {
                that.$message.error('请输入验证码');
                return;
            }
            if (that.row.password == '') {
                that.$message.error('请输入密码');
                return;
            }
            if (that.row.email == '') {
                that.$message.error('请输入邮箱');
                return;
            }
            let obj = {
                email: that.row.email,
                code: that.row.code,
                password: that.row.password
            };
            that.$post('/backapi/reset_password', obj).then(function (res) {
                if (res.code == 200) {
                    that.row = {};
                    that.$message.success('修改成功');
                    localStorage.removeItem('user');
                    localStorage.removeItem('user_type');
                    localStorage.removeItem('token');
                    localStorage.removeItem('area');
                    that.$router.replace('/login');
                } else {
                    that.$message.error(res.mag);
                }
            });
        },
        handleCommand() {
            this.$confirm('确定退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    //点击确定的操作(调用接口)
                    localStorage.removeItem('user');
                    localStorage.removeItem('user_type');
                    localStorage.removeItem('token');
                    localStorage.removeItem('area');
                    this.$router.replace('/login');
                })
                .catch(() => {
                    return;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.ml15 {
    margin-left: 15px;
}

/deep/.el-menu--inline {
    // width: 140px !important;
    padding-left: 30px !important;
    box-sizing: border-box !important;
}
/deep/.el-menu--inline.el-menu-item menu_item {
    width: 100% !important;
}
/deep/.submenu .el-submenu__title {
    padding: 0 0 0 10px !important;
    height: 40px !important;
    line-height: 40px !important;
}
/deep/.submenu2 .el-submenu__title {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}
/deep/.el-submenu__title {
    height: 40px !important;
    line-height: 40px !important;
    margin-bottom: 10px !important;
}
.submenu {
    margin-bottom: 10px !important;
}
/deep/.el-menu.menu_item {
    padding: 0 0 0 20px !important;
}
/deep/.el-submenu .el-menu-item {
    min-width: 100% !important;
}
.box {
    width: 200px;
    background: #16307c;
    height: 100vh;
    position: absolute;
    left: 0px;
    top: 0px;
    padding: 20px;
    bottom: 0;
    overflow-y: scroll;
    -webkit-transition: left 0.3s ease-in-out;
    transition: left 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .el_menu {
        border-right: none;
        // height: 400px;
        overflow: auto;
        .img_i {
            width: 24px;
            height: 24px;
        }
        .img_box {
            background: #2f5de3;
            border-radius: 8px;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .items_title {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            margin-left: 8px;
        }
    }

    .logo_img {
        width: 100%;
        height: 48px;
        margin-bottom: 41px;
    }
    .logo_img1 {
        width: 45.76px;
        height: 45.53px;

        margin-bottom: 43px;
    }
    .u_footer {
        // position: absolute;
        // bottom: 20px;
        // left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        .suo_img {
            width: 17.96px;
            height: 21.9px;
        }
        .pic_img {
            width: 36px;
            height: 36px;
            border-radius: 32px;
        }
        .pic_title {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 100%;
            color: #ffffff;
        }
        .ml8 {
            margin-left: 8px;
        }
        .u_fown {
            display: flex;
            flex-direction: column;
            align-items: center;
            .suo_pic1 {
                margin: 16px 0 8px 0;
            }
        }

        .mb27 {
            margin-bottom: 27px;
        }
        .changeMi {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 100%;
            color: #ffffff;
            margin-left: 8px;
        }
        .mima {
            display: flex;
            align-items: center;
            width: 160px;
            height: 48px;
            background: rgba(145, 217, 242, 0.2);
            border-radius: 8px;
            .mima_p {
                width: 100%;
                padding: 4px 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .p_l {
                    display: flex;
                    align-items: center;
                }
                .right {
                    width: 22.5px;
                    height: 21.75px;
                    color: #fff;
                    cursor: pointer;
                }
            }
        }
    }
}
.box1 {
    width: 78px !important;
    -webkit-transition: right 0.3s ease-in-out;
    transition: right 0.3s ease-in-out;
    // padding: 20px 16px !important;
}
::-webkit-scrollbar {
    display: none;
}
/deep/.el_menu :hover {
    background: none !important;
}
/deep/.el-menu-item {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    padding: 0 0 0 10px !important;
}
/deep/.el-menu--collapse {
    width: initial !important;
    display: flex;
    flex-direction: column;
    align-items: center;
}
/deep/.el-menu-item.is-active {
    background: rgba(145, 217, 242, 0.2) !important;
    border-radius: 8px;
    line-height: 0px !important;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0 0 8px !important;
}

/deep/.el-menu-item.is_active1 {
    background: none !important;
    padding: 0 !important;
}
// /deep/.submenu1 .el-submenu__title {
//     padding: 0 !important;
// }
// /deep/.el-menu-item .el-tooltip {
//     padding: 0 !important;
// }
// .a {
//     &:hover {
//         background: #fff !important;
//     }
//     .bg {
//         width: 100px;
//         height: 70px;
//         position: absolute;
//         top: 0;
//         z-index: 9999;
//         right: -100px;
//         background: #fff;
//         width: 100px;
//         height: 70px;
//         display: flex;
//         flex-direction: column;
//         justify-content: space-around;
//         align-items: center;
//         border: 1px solid #dde1e6;
//         box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2);
//         border-radius: 8px;
//         &:hover {
//             background: #fff !important;
//         }
//         .active {
//             font-family: 'PingFang SC';
//             font-style: normal;
//             font-weight: 400;
//             font-size: 14px;
//             line-height: 110%;
//             color: #697077;

//             &:hover {
//                 background: #fff !important;
//             }
//         }
//         .color69 {
//             color: #21272a !important;
//             &:hover {
//                 background: #fff !important;
//             }
//         }
//     }
// }

// /deep/.el-submenu .el-menu-item {
//     min-width: auto !important;
// }
// /deep/.el-submenu__title {
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     padding: 0px 10px !important;
//     width: 100%;
//     height: 40px;
//     // margin-bottom: 16px;
//     line-height: 0 !important;
//     margin-right: 0 !important;
// }
.getCode {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 137px;
    height: 36px;
    background: #16307c;
    box-shadow: 0px 0px 4px rgba(8, 32, 102, 0.2);
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;

    letter-spacing: 0.5px;
    /* Default/White */

    color: #ffffff;
    position: absolute;
    top: 6px;
    right: 8px;
}

/deep/.el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.el-form-item__label {
    font-family: 'PingFang SC';
    font-weight: 400;
    font-size: 14px;
    color: #21272a;
}
.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 129px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
}

/deep/.v_dol .el-dialog {
    background: #ffffff;
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}
/deep/.v_dol .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}
// .sidebar1 {
//     padding: 23px 16px 0 16px !important;
// }
// .el-menu-item .img_i {
//     color: #fff;
//     width: 24px;
//     height: 24px;

// }
// /deep/.sidebar1 .el-menu-item {
//     padding: 0 !important;
// }
// .sidebar1 .img_box {
//     margin-right: 0 !important;
// }
// .img_i {
//     width: 24px;
//     height: 24px;
//     position: relative;
// }
// .el-menu-item.is-active .img_i {
// }
// .img_box {
//     width: 32px;
//     height: 32px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: #2f5de3;
//     border-radius: 8px;
//     // margin-right: 14px;
// }
// .img_box1 {
//     // margin-right: 14px;
//     width: 32px;
//     height: 32px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
// }
// .title {
//     margin-left: 14px;
// }
// .title {
//     font-family: 'PingFang SC';
//     font-style: normal;
//     font-weight: 400;
//     font-size: 16px;
//     color: #ffffff;
// }
// .left {
//     position: absolute;
//     width: 26px;
//     height: 26px;
//     left: 187px;
//     top: 76px;
//     background: #effafe;
//     border-radius: 50%;
//     z-index: 99;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     img {
//         width: 24px;
//         height: 24px;
//     }
// }
// .left-collapse {
// }
// .logo {
//     width: 36px;
//     height: 36px;
//     margin-right: 8px;
// }
// .test {
//     font-family: 'PingFang SC';
//     font-style: normal;
//     font-weight: 400;
//     font-size: 16px;
//     color: #ffffff;
// }
// .icon {
//     width: 17.96px;
//     height: 21.9px;
//     margin-right: 14px;
// }
// .v_bottom {
//     // margin-top: 162px;
//     position: absolute;
//     bottom: 20px;
//     .fown {
//         display: flex;
//         flex-direction: column;
//         align-items: center;
//         .logo {
//             margin: 16px 0 8px 0 !important;
//         }
//         .icon {
//             margin: 0 !important;
//         }
//         .title {
//             margin: 0 !important;
//         }
//     }
// }
// .v_mima {
//     width: 174px;
//     height: 24px;
//     cursor: pointer;
//     div {
//         display: flex;
//         align-items: center;
//         padding: 0 21px;
//     }
// }
// .mima {
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     width: 160px;
//     height: 48px;
//     margin-top: 27px;
//     background: rgba(145, 217, 242, 0.2);
//     border-radius: 8px;
//     .mima_p {
//         width: 100%;
//         padding: 4px 8px;
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         .p_l {
//             display: flex;
//             align-items: center;
//         }
//         .right {
//             width: 22.5px;
//             height: 21.75px;
//             color: #fff;
//             cursor: pointer;
//         }
//     }
// }
// .mima1 {
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     width: 100%;
//     height: 48px;
//     margin-top: 27px;

//     .mima_p {
//         width: 100%;
//         padding: 4px 8px;
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         .p_l {
//             display: flex;
//             align-items: center;
//         }
//         .right {
//             width: 22.5px;
//             height: 21.75px;
//             color: #fff;
//         }
//     }
// }
// .sidebar {
//     position: absolute;
//     width: 200px;
//     left: 0px;
//     top: 0px;
//     height: 100vh;
//     background: #16307c;
//     padding: 20px;
//     box-sizing: border-box;
//     box-sizing: border-box;
//     left: 0;
//     top: 0px;
//     bottom: 0;
//     overflow-y: scroll;
// }

// .top {
//     width: 100%;
//     height: 48px;
//     margin-bottom: 41px;
// }
// .top1_img {
//     justify-content: center;
// }
// .top1 {
//     width: 45.76px;
//     height: 45.53px;
//     margin-bottom: 43px;
//     // margin-top: 42px;
// }

// .sidebar::-webkit-scrollbar {
//     width: 0;
// }
// .sidebar-el-menu:not(.el-menu--collapse) {
//     width: 100%;
// }
// .sidebar-el-menu {
//     border-right: none !important;
// }
// .sidebar-el-menu :hover {
//     // background: #16307c !important;
// }
// .sidebar-el-menu1 {
//     border-right: none !important;
// }

// .sidebar-el-menu1 .img_box1 {
//     margin: 0 !important;
// }
// .sidebar-el-menu1 :hover {
//     background: #16307c !important;
// }
// .sidebar > ul {
//     /* height: 100%; */
// }
// .sidebar .el-menu-item.is-active {
//     // padding: 4px 8px !important;
//     // width: 100%;
//     height: 40px;
//     background: rgba(145, 217, 242, 0.2) !important;
//     border-radius: 8px;
//     line-height: 0px !important;
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     box-sizing: border-box;
// }
// /deep/.sidebar .el-menu-item.menu_item1 {
//     background: none !important;
// }

// .sidebar1.el-menu-item.is-active {
//     // background-color: rgb(22, 48, 124) !important;
// }

// .el-menu-item {
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     padding: 0px 10px !important;
//     // width: 100%;
//     height: 40px;
//     // margin-bottom: 16px;
//     line-height: 0 !important;
//     margin-right: 0 !important;
// }
</style>
